export default __webpack_public_path__ + "d2b55e738c71cbe26f69fae9de214411.png";